import { REFRESH_LOCATION_GROUPS } from '../actions/types'

const INITIAL_STATE = {
  list: [],
  data: {},
  refreshCycle: 0
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REFRESH_LOCATION_GROUPS:
      return { ...state, refreshCycle: state.refreshCycle + 1 }
    default:
      return state
  }
}
